<template>
    <div class="comarchReview" v-loading="loader">
        <div class="product-list">

            <div class="pagination">
                <div class="page-subtitle">{{ total_item }} produits</div>
                <el-pagination @current-change="page => paginate(page, 'top')" :current-page.sync="params.page" :page-size="params.limit" :pager-count="11" layout="sizes, prev, pager, next" :page-sizes="page_sizes" @size-change="handleSizeChange" :total="total_item"></el-pagination>
            </div>

            <template v-if="multipleSelection.length || applyAllResults">
                <el-button @click="modalConfirm = true" >Syncroniser les informations sur Comarch</el-button>
                <el-button type="warning" @click="removeReview" >Supprimer de la review</el-button>
            </template>

            <template v-if="user.email == 'info@divioseo.fr'">
                <el-button type="default" @click="removeReview('all')" >reset review</el-button>
            </template>

            <div class="mt-3">
                <el-checkbox v-model="applyAllResults">Appliquez à toute la review</el-checkbox>
            </div>

            <hr>

            <el-table style="width: 100%" ref="multipleTable" :row-class-name="tableRowClassName" :data="products" @selection-change="handleSelectionChange" stripe @sort-change="changeSort" v-loading="loading">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column prop="visuel" width="55">
                    <template slot-scope="scope">
                        <el-badge :value="scope.row.images.length" class="item">
                            <a v-if="scope.row.images.length" href="#" @click.prevent="openLightbox(scope.row.image)" class="mb-3">
                                <span class="avatar" :style="{backgroundImage: 'url(\'/ic/thumbnail/'+scope.row.image.path+'\')'}"></span>
                            </a>
                        </el-badge>
                    </template>
                </el-table-column>
                <el-table-column prop="shop_id" label="Ref Speedway / ID" sortable="custom" width="150">
                    <template slot-scope="scope">
                        {{ scope.row.shop_id }}
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="Titre" sortable="custom" >
                    <template slot-scope="scope">
                        {{ scope.row.name }}
                    </template>
                </el-table-column>
                <el-table-column prop="brand" label="Marque" sortable="custom">
                    <template slot-scope="scope">
                        <span v-if="scope.row.brand">{{ scope.row.brand.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="external_ref" label="Ref fournisseur" sortable="custom" width="200">
                    <template slot-scope="scope">
                        {{ scope.row.mf_prefixe }} / {{ scope.row.external_ref }}
                    </template>
                </el-table-column>
                <el-table-column prop="comarch_review_at" label="Date review" sortable="custom" width="170">
                    <template slot-scope="scope">
                        <span class="is-recent">{{ scope.row.comarch_review_at }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="comarch_review_user_name" label="Utilisateur" sortable="custom" >
                    <template slot-scope="scope">
                        {{ scope.row.comarch_review_user_name }}
                    </template>
                </el-table-column>
                <el-table-column label="Dates" sortable="custom" width="170">
                    <template slot-scope="scope">
                        <div>Date de création : {{scope.row.comarch_created_at}}</div>
                        <div>Date de mise à jour : {{scope.row.comarch_updated_at}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="Actions" width="70">
                    <template slot-scope="scope">
                        <a class="icon" v-if="user.can('preview product')" @click="openModalPreviewCrapi(scope.row)">
                            <i class="fe fe-eye"></i>
                        </a>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination :page-size="params.limit" layout="sizes, prev, pager, next" :pager-count="11" :total="total_item" @current-change="page => paginate(page, 'bottom')" :page-sizes="page_sizes" @size-change="handleSizeChange" :current-page="params.page">
                </el-pagination>
            </div>
        </div>

        <el-dialog class="lightbox-galery" @closed="cleanLigtbox" :visible.sync="lightbox.display" fullscreen append-to-body>
            <div slog="title">
                <h4>{{ lightbox.image.filename }}</h4>
                <span v-for="(tag, indexTag) in lightbox.image.tags" :key="indexTag" class="badge badge-secondary mx-1">{{ tag.name }}</span>
            </div>
            <div class="lightox-galery-ctn my-3" v-loading="lightbox.loader" v-if="lightbox.image.path">
                <img @load="lightbox.loader = false" :src=" '/ic/original/' + lightbox.image.path" :alt="lightbox.image.filename">
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="lightbox.display = false">Fermer</el-button>
            </span>
        </el-dialog>

        <el-dialog title="Json Envoyé à CRAPI" :visible.sync="modalPreviewCrapi.display" width="95%" top="2vh" bottom="2vh">
            <pre>{{ modalPreviewCrapi.preview }}</pre>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeModalPreviewCrapi">Fermer</el-button>
            </span>
        </el-dialog>

        <el-dialog title="Attention - Syncroniser les produits ?" :visible.sync="modalConfirm" width="30%" @closed="handleCloseModalConfirm" >
            <span slot="footer" class="dialog-footer">
                <el-button @click="modalConfirm = false">Annuler</el-button>
                <el-button type="primary" @click="syncSelected">Confirmer</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import { EventBus } from '../../event-bus';
import Product from '../../models/Product';

export default {
    data() {
        return {
            multipleSelection: [],
            applyAllResults: false,
            modalConfirm: false,
            modalChange: false,
            modalChangeProduct: null,
            modalErrors: false,
            modalErrorsProduct: null,
            configSync: {
                'override-images': false,
                'force-slug': false,
                'force-new': null
            },
            page_sizes: [10, 20, 30, 40, 50, 100, 200],
            params: {
                page: 1,
                orderBy: 'updated_at',
                order: 'DESC',
                limit: 10
            },
            defaultParams: {
                page: 1,
                orderBy: 'updated_at',
                order: 'DESC',
                limit: 10
            },
            filters: {},
            loading: false,
            modalPreviewCrapi: {
                display: false,
                preview: {}
            },
            lightbox: {
                display: false,
                image: {},
                loader: true
            },
            modal: {
                display: false,
                product: {}
            },
        };
    },
    computed: {
        total_item() {
            return this.$store.getters['products/totalItems'];
        },
        products() {
            return this.$store.getters['products/items'];
        },
        currentUrl() {
            return (
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname
            );
        },
        loader: {
            get() {
                return this.$store.getters['products/loader'];
            },
            set(value) {
                this.$store.dispatch('products/setLoader', value);
            }
        },
        appEnv() {
            return this.$store.getters['app/env'];
        },
        user() {
            return this.$store.getters['app/user'];
        }
    },
    mounted() {
        this.fetch();
        EventBus.$on('products.list.refresh', () => {
            this.fetch();
        });
    },

    methods: {
        tableRowClassName({row, rowIndex}) {
            var className = 'manufacturer-' + row.manufacturer_slug;
            if(row.is_stock_hybrid !== null){
                className = className + ' hybrid';
            }
            if( row.end_of_life ) {
                if( row.has_stock){
                    className = className + ' end-of-life';
                }else{
                    className = className + ' very-end-of-life';
                }
            }
            return className;
        },
        handleSelectionChange(val) {
            this.$store.dispatch('products/setApplyToAllResults', false);
            this.multipleSelection = val;
        },

        cleanTypeParams(params) {
            for (let i in params) {
                if (params[i] == 'false') {
                    params[i] = false;
                } else if (params[i] == 'true') {
                    params[i] = true;
                }
            }
            return params;
        },


        fetch(params) {
            if (!params) {
                params = {};
            }
            params = this.cleanTypeParams({ ...params, ...this.params });
            this.loading = true;
            return this.$store.dispatch('products/comarchReview', params).then(() => {
                this.loading = false;
            });
        },


        goToPage(p) {
            this.params.page = p;
            this.fetch();
        },

        changeSort(s) {
            this.params.orderBy = s.prop;
            this.params.order = s.order == 'ascending' ? 'asc' : 'desc';

            this.fetch();
        },


        handleSizeChange(val) {
            this.params.limit = val;
            this.fetch();
        },


        paginate(page, paginator) {
            this.params.page = page;
            this.loader = true;
            this.fetch()
                .then(r => {
                    if (paginator == 'bottom') {
                        var element = document.querySelector(
                            '.catalog .product-list'
                        );
                        element.scrollIntoView();
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        },

        openModalPreviewCrapi(product) {
            axios.get('/comarch-review/preview-crapi/'+product.id).then((r)=>{
                this.modalPreviewCrapi.display = true;
                this.modalPreviewCrapi.preview = JSON.stringify(r.data, undefined, 2);
            })
        },

        closeModalPreviewCrapi() {
            this.modalPreviewCrapi.display = false;
        },

        openModalChange(product) {
            this.modalChange = true;
            this.modalChangeProduct = product;
        },

        openModalErrors(product) {
            this.modalErrors = true;
            this.modalErrorsProduct = product;
        },

        openLightbox(image) {
            this.lightbox.loader = true;
            this.lightbox.image = {};
            this.$nextTick(function() {
                this.lightbox.image = image;
                this.lightbox.display = true;
            });
        },
        cleanLigtbox() {
            this.lightbox = {
                display: false,
                image: {},
                loader: true
            };
        },
        handleCloseModalConfirm()
        {
            this.configSync['override-images'] = false;
        },
        syncSelected()
        {
            let selected = this.multipleSelection.map(v=>v.id);

            axios.post('/products/syncMany', {
                products: selected,
                config: this.configSync,
                direction: 'comarch',
                applyAllResults: this.applyAllResults
            }).then(()=>{
                this.fetch()
                this.configSync['override-images'] = false;
                this.modalConfirm = false;
            })

        },
        removeReview( type = 'selected' )
        {
            this.$confirm('Êtes-vous sûr ?', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
            .then(() => {
                if(this.applyAllResults) {
                    type = 'all';
                }
                let selected = this.multipleSelection.map(v=>v.id);

                axios.post('/products/comarchRemoveReview', {
                    products: selected,
                    type: type
                }).then(()=>{
                    this.fetch()
                })
            }).catch(()=>{

            })

        },
        openModalEdit(product) {
            axios.get('products/'+ product.id).then((r)=>{
                this.modal.product = new Product(r.data.data);
                this.modal.display = true;
            })
        },
        closeModalEdit() {
            this.modal.display = false;
            this.modal.product = {};
        },
        onUpdateProduct(product) {
            this.closeModalEdit();
        },
    }
};
</script>
<style lang="scss">
.comarchReview {
    .pagination {
        margin: 25px 0;
        .el-pagination {
            margin: 0 auto;
        }
    }
    .is-recent {
        font-weight: bold;
        color: #009e2c;
    }
    .manufacturer-speedway {
        background-color: #b7ffdb47;
        &.hybrid{
            background-color: #e1b7ffe6;
        }
    }

    .very-end-of-life {
        background-color: #cc4747e6;
        color: #FFF;
    }

    .end-of-life {
        background-color: #ec8c4be6;
        color: #FFF;
    }

    .el-table--striped .el-table__body tr.el-table__row--striped.very-end-of-life td {
        background-color: #cc5f5fe6;
        color: #FFF;
    }

    .el-table--striped .el-table__body tr.el-table__row--striped.end-of-life td {
        background-color: #ec9b65e6;
        color: #FFF;
    }

    .el-table--striped .el-table__body tr.el-table__row--striped.manufacturer-speedway td {
        background-color: #b7ffdb47;
    }
    .warning-zone {
        color: #e6a23c;
        background-color: #fdf6ec;
        padding: 8px 16px;
        box-sizing: border-box;
        border-radius: 4px;
        width: 100%;
        .el-checkbox__label {
            color: #e6a23c;
        }
    }
}

.lightbox-galery {
    .el-dialog__body {
        height: 89vh;
        text-align: center;
        .lightox-galery-ctn {
            height: 77vh;
        }
        img {
            height: 100%;
            object-fit: contain;
        }
    }
}
.el-table__row {
    .el-badge__content.is-fixed {
        top: 10px;
        line-height: 14px;
    }
}
</style>
